/* eslint-disable @typescript-eslint/no-explicit-any */
import { Checkbox, CheckboxProps, Col, Input, Row, Select } from 'antd';
import Search from 'antd/es/input/Search';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import axiosInstance from '../../../axios_instance';
import { getDropdownOptions } from '../../../hooks/GetDropdownOptions';
import { SelectStringInput } from '../../general/select-input';
import styles from './styles.module.scss';

const StyledSelectStringInput = styled(SelectStringInput)`
  && {
    width: 100%;
  }
  .ant-select-selection-item {
    line-height: 37px !important;
  }
  .ant-select-selection-placeholder {
    line-height: 36px !important;
    color: #9e9e9e;
  }
  .ant-select-selector {
    height: 40px !important;
  }
  .ant-select-selection-item-remove {
    line-height: 17px;
  }
`;

const StyledSelect = styled(Select)`
  && {
    width: 100%;
  }
  .ant-select-selection-item {
    line-height: 37px !important;
  }
  .ant-select-selection-placeholder {
    line-height: 36px !important;
    color: #9e9e9e;
  }
  .ant-select-selector {
    height: 40px !important;
  }
  .ant-select-selection-item-remove {
    line-height: 17px;
  }
`;
const StyledCheckedbox = styled(Checkbox)`
  && {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .ant-checkbox-inner {
    background-color: #fff;
    border: 1px solid #d9d9d9;
  }
  .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
    background-color: #4096ff;
    border-color: transparent;
  }
`;
const StyledMultipleSelect = styled(Select)`
  && {
    height: 100%;
    width: 100%;
  }
  .ant-select-selector {
    height: 40px !important;
  }
  .ant-select-selection-placeholder {
    line-height: 40px !important;
    color: #9e9e9e;
  }
  .ant-select-selection-item-remove {
    line-height: 17px;
  }
`;
const StyleSearch = styled(Search)`
  && {
    width: 100%;
  }
  .ant-input {
    height: 40px !important;
  }
  .ant-btn {
    background: #478bbc;
    height: 40px !important;
    border: none;
  }
`;

const StyleInput = styled(Input)`
  && {
    height: 40px;
  }
`;

interface AdvancedSearchComponentProps {
  setUrl: any;
  setPage: any;
  searchCriteriaList: Array<{ label: string; value: string }>;
  baseUrl: string;
  setDisabledSearch: any;
}

const AdvancedSearchComponent: React.FC<AdvancedSearchComponentProps> = ({
  setUrl,
  setPage,
  setDisabledSearch,
  baseUrl,
  searchCriteriaList,
}: AdvancedSearchComponentProps) => {
  const [dropdownOption, setDropdownOption] = useState<{
    [index: string]: Array<{ value: string; label: string }>;
  }>({});
  const [OPTIONS, setOPTIONS] = useState<Array<any>>([]);
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const [skillId, setSkillId] = useState<string>();
  const [skillExperienceYear, setSkillExperienceYear] = useState<number>(0);
  const [totalExperienceYear, setTotalExperienceYear] = useState<number>();
  const [profileStatus, setProfileStatus] = useState(true);
  const [clientEngaged, setClientEngaged] = useState();
  const [designationList, setDesignationList] = useState<any>([]);
  const [genderValue, setGenderValue] = useState<number>();
  const [designationValue, setDesignationValue] = useState<number>();
  const navigation = useNavigate();

  const handleSearchByKeyWord = (value: any, event: any) => {
    if (value) {
      setTotalExperienceYear(value);
    } else {
      setTotalExperienceYear(undefined);
    }

    const queryParams = [];

    // Set individual parameters based on conditions
    if (skillId) {
      queryParams.push('advanced_search_skill_id=' + skillId);
    }
    if (value) {
      queryParams.push('advanced_search_total_experience_year=' + value);
    }
    if (clientEngaged) {
      queryParams.push('resource_engaged=' + clientEngaged);
    }
    if (designationValue) {
      queryParams.push('designation=' + designationValue);
    }
    if (selectedItems) {
      queryParams.push(
        selectedItems.map((item: any) => 'skill-id' + '=' + item + '&').join('')
      );
    }
    if (profileStatus) {
      queryParams.push('profile_status=' + 1);
    } else {
      queryParams.push('profile_status=' + 4);
    }

    // Construct URL based on parameters
    const urlParams = queryParams.join('&');
    const finalUrl = baseUrl + (urlParams ? '?' + urlParams : '');

    // Set URL and reset page
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('page-number', '1');
    navigation({ search: searchParams.toString() });
    setDisabledSearch(true);
    setUrl(finalUrl);
    setPage(1);
  };

  useEffect(() => {
    getDropdownOptions(searchCriteriaList, setDropdownOption);
  }, []);

  // useEffect(() => {
  //   if (skillId && SearchTypeMapping[searchQuery] === 'dropdown') {
  //     setOPTIONS(dropdownOption[searchQuery]);
  //   }
  // }, [searcskillIdhQuery]);

  const handleQuery = (e: any) => {
    setSkillId(e);
    // if (e === 'all') {
    //   setUrl(baseUrl);
    // }
    setPage(1);
  };

  const handleClientEngaged = (e: any) => {
    setClientEngaged(e);
    setPage(1);
  };

  const handleDesignation = (e: any) => {
    setDesignationValue(e);
    setPage(1);
  };

  const handleTotalExperienceYearChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (e.target.value) {
      setTotalExperienceYear(parseInt(e.target.value));
    } else {
      setTotalExperienceYear(undefined);
    }
    // Do something with the value here, such as updating state or calling a function
  };

  useEffect(() => {
    if (skillExperienceYear) {
      setUrl(baseUrl + `?`);
      setPage(1);
    }
  }, [selectedItems]);

  let transformedArray: any = [];
  if (dropdownOption && dropdownOption['skill-id']) {
    transformedArray = dropdownOption['skill-id'].map((obj) => {
      const [key, value] = Object.entries(obj)[0];
      return { label: key, value: value };
    });
  } else {
    transformedArray = [];
  }

  const clientEngagedArray = [
    { label: 'Select Engaged Type', value: null },
    { label: 'Fully Engaged', value: 1 },
    { label: 'Partially Engaged', value: 2 },
    { label: 'Not Engaged', value: 3 },
  ];
  const onCheckboxChange: CheckboxProps['onChange'] = () => {
    setProfileStatus(!profileStatus);
  };

  console.log('dropdownOption: ', dropdownOption);
  const handleSelectedItems = (e: any) => {
    setSelectedItems(e);
    setPage(1);
  };

  useEffect(() => {
    axiosInstance
      .get('/api/v1/designations')
      .then((response) => {
        let designationList = [];
        designationList = response.data.map((des: any) => {
          return { label: des.designation, value: des.designation_id };
        });
        designationList.unshift({ label: 'Select Designation', value: null });
        setDesignationList(designationList);
      })
      // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
      .catch((error) => {});
  }, []);
  console.log('test: ', clientEngagedArray, designationList);
  return (
    <>
      <Row gutter={[16, 0]} align={'middle'}>
        <Col span={5}>
          <StyledSelect
            className={styles['ant-select']}
            onChange={handleDesignation}
            options={designationList}
            placeholder="Select Designation"
            dropdownMatchSelectWidth={true}
            getPopupContainer={(triggerNode) => triggerNode.parentElement}
            virtual={false}
            defaultValue={'Select Designation'}
          />
        </Col>
        <Col span={7}>
          <StyledMultipleSelect
            className={styles['search-box']}
            mode="multiple"
            placeholder={'Search by skills'}
            showSearch
            value={selectedItems}
            onChange={handleSelectedItems}
            optionFilterProp="label"
            maxTagCount={3}
            showArrow
            onClick={(e) => e?.stopPropagation()}
            dropdownMatchSelectWidth={true}
            getPopupContainer={(triggerNode) => triggerNode.parentElement}
          >
            {transformedArray.map((item: any) => (
              <Select.Option
                key={item.label}
                value={item.value}
                label={item.label}
              >
                {item.label}
              </Select.Option>
            ))}
          </StyledMultipleSelect>
        </Col>

        <Col span={5}>
          <StyledSelect
            className={styles['ant-select']}
            onChange={handleClientEngaged}
            options={clientEngagedArray}
            placeholder="Engaged Type"
            dropdownMatchSelectWidth={true}
            getPopupContainer={(triggerNode) => triggerNode.parentElement}
            virtual={false}
            defaultValue={'Select Engaged Type'}
          />
        </Col>
        <Col span={2}>
          <StyledCheckedbox
            onChange={onCheckboxChange}
            name="profile_status"
            checked={profileStatus}
          >
            Status(Active)
          </StyledCheckedbox>
        </Col>
        <Col span={5}>
          <StyleSearch
            enterButton={<img src="/search.png" />}
            className={styles['search-box']}
            onSearch={handleSearchByKeyWord}
            placeholder="Emp Experience"
          />
        </Col>
      </Row>
    </>
  );
};

export default AdvancedSearchComponent;
